module.exports = __webpack_public_path__ + "media/images/emblems/Betten-coat_of_arms-33f0ce4d2fc004d35adf44b9c191e2c3.svg";